import { BreadcrumComponent } from '../breadcrum/breadcrum.component';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, Input, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-alert',
  standalone: true,
  imports: [CommonModule, BreadcrumComponent],
  templateUrl: './notification-alert.component.html',
  styleUrl: './notification-alert.component.scss',
  animations: [
    trigger('slidePanel', [
      state('hidden', style({ transform: 'translateX(100%)' })),
      state('visible', style({ transform: 'translateX(0%)' })),
      transition('hidden => visible', animate('300ms ease-in-out')),
      transition('visible => hidden', animate('300ms ease-in-out')),
    ]),
  ],
})
export class NotificationAlertComponent implements OnInit {
  @Input() isStandalone: boolean = true;
  notificationBreadcrumbs: any[] = [{ label: 'Notifications', url: null }];
  activeTab = 'all';
  isMobile = false;

  constructor(private router: Router) {}

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  ngOnInit() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 768; // md breakpoint
  }

  switchTab(tab: string) {
    this.activeTab = tab;
  }

  onNotificationClick(notificationType: string, orderId?: string) {
    // Navigate based on notification type
    if (notificationType === 'order' && orderId) {
      this.router.navigate(['/orders', orderId]);
    } else if (notificationType === 'cart') {
      this.router.navigate(['/cart']);
    } else if (notificationType === 'offer') {
      this.router.navigate(['/coupons-offers']);
    }
  }

  showPanel = false;
  originalNotifications = [];

  togglePanel() {
    this.showPanel = !this.showPanel;
    this.originalNotifications = JSON.parse(JSON.stringify(this.notifications));
  }

  savePanel() {
    this.showPanel = false; // Close the panel after saving
    this.originalNotifications = JSON.parse(JSON.stringify(this.notifications));
  }

  closePanel() {
    this.showPanel = false; // Close the panel after cancle
    this.notifications = JSON.parse(JSON.stringify(this.originalNotifications));
    this.showPanel = false;
  }

  notifications = [
    { name: 'Email', enabled: true },
    { name: 'SMS', enabled: true },
    { name: 'WhatsApp', enabled: true },
  ];

  onCheckboxChange(item: any, event: Event) {
    const target = event.target as HTMLInputElement;
    item.enabled = target.checked;
  }
}
